var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BillingPlan',{attrs:{"qso":_vm.qso,"endpoint":_vm.endpoint,"pageTitle":_vm.$t('components.billingPlanManagement.headline'),"isShowOnlyPageTitle":true}})}
var staticRenderFns = []

export { render, staticRenderFns }